module.exports = __webpack_public_path__ + "6ba26506960f92e0d57372459dbbe9ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/media2.jpg
// module id = 190
// module chunks = 0